import styles from "../../index.module.scss";
import { NameAvatar } from "../../../nameImage";
import moment from "moment";
import { NameReturn } from "./Chat_Header";



export const changeTime = (timeString) => {
  return moment(new Date(timeString).toUTCString()).format("hh : mm A");
};

export const RecievedMessage = ({ userData, messageData }) => {
  return (
    <div className={styles.chat__messages__left}>
      <div className={styles.chat__messages__left__img}>
        {userData.photoUrl ? (
          <img
            src={userData.photoUrl}
            alt="user"
          />
        ) : (
          <NameAvatar
            firstName={NameReturn(userData).split(" ")[0]}
            lastName={NameReturn(userData).split(" ")[1]}
            width={"3.125rem"}
            height={"3.125rem"}
            classes={""}
            size={"1rem"}
          />
        )}
      </div>
      <div className={styles.chat__messages__left__text}>
        <p>{messageData.message}</p>
        <div className={styles.chat__messages__right__text__timing}>
          <span>{changeTime(messageData.createdAt)}</span>
        </div>
      </div>
    </div>
  );
};

export const RecievedAgainMessage = ({ userData, messageData }) => {
  return (
    <div className={styles.chat__messages__left__again}>
      <div className={styles.chat__messages__left__text__again}>
        <p>{messageData.message}</p>
        <div className={styles.chat__messages__right__text__timing}>
          <span>{changeTime(messageData.createdAt)}</span>
        </div>
      </div>
    </div>
  );
};
